const localStorageInstance = window && window.localStorage
/** 缓存名*/
export enum enStorageName {
  /** 通用数据源 */
  CommonData,  
  /** 用户菜单 */
  Menus,
  /** 用户验证信息 */
  UserAuth,
  /** 密码修改提示，密码太简单或者长时间未更改时给出提示 */
  ChangePwdTips,
  /** 登陆后，如果菜单只有一条记录，系统自动导航到该页面，所以菜单栏不需要显示。 */
  HiddenSidebar,
  /** 首页数据看板中各个查询条件的数据源 */
  DataBoard
}

interface StorageData {
  getItem: (key: string) => string
  setItem: (key: string, value: string) => void
  removeItem: (key: string) => void
  clear: () => void
}
class MockStorage implements StorageData {
  private store: { [key: string]: any } = {}

  public getItem(key: string) {
    return this.store[key]
  }
  public setItem(key: string, value: string) {
    value = value || ''
    this.store[key] = value
  }
  public removeItem(key: string) {
    delete this.store[key]
  }
  public clear() {
    this.store = {}
  }
}

const sysLocalStorage = (localStorageInstance as StorageData) || (new MockStorage())

export default sysLocalStorage
